import { EVMChain } from '@repo/types-client';

/**
 * Represents the details of a contract.
 * @interface ContractDetails
 * @property {string} name - The name of the contract.
 * @property {EVMChain} chain - The blockchain chain of the contract.
 * @property {string} contractType - The type of the contract.
 */
export interface ContractDetails {
  name: string;
  chain: EVMChain;
  contractType: string;
}

/**
 * A mapping of claim contracts with their details.
 * @const {ContractDetails[]} claimContractMapping
 */
export const claimContractMapping: ContractDetails[] = [
  {
    name: 'Doodles',
    chain: EVMChain.ethereum,
    contractType: 'ERC721',
  },
  {
    name: 'SpaceDoodles',
    chain: EVMChain.ethereum,
    contractType: 'ERC721',
  },
  {
    name: 'Dooplicator',
    chain: EVMChain.ethereum,
    contractType: 'ERC721',
  },
  {
    name: 'GenesisBox',
    chain: EVMChain.ethereum,
    contractType: 'ERC721',
  },
  {
    name: 'Wearable',
    chain: EVMChain.base,
    contractType: 'ERC7401',
  },
  {
    name: 'Pass',
    chain: EVMChain.base,
    contractType: 'ERC1155',
  },
  {
    name: 'DoodlesCertifiedViral',
    chain: EVMChain.external_base,
    contractType: 'ERC1155',
  },
];
